import { Activity } from "@com.mgmtp.a12.client/client-core/lib/core/activity";

export const formModels = {
	ANTRAG_F: "Antrag_F",
	WIEDERVORLAGE_F: "Wiedervorlage_F"
};
export const dataModels = {
	ANTRAG_D: "Antrag_D",
	WIEDERVORLAGE_D: "Wiedervorlage_D",
	WIEDERVORLAGE_WITH_PROCESS_D: "WiedervorlageWithProcess_D"
};
export const overviewModels = {
	WIEDERVORLAGEN_O: "Wiedervorlagen_O"
};
export function prefix(resourceName: string, activity: Activity) {
	return `${activity.descriptor.fachverfahren}_${resourceName}`;
}
